<div class="panel p-4 bg-white dark:bg-black rounded-lg shadow-md">
    <h5 class="text-lg font-semibold text-center dark:text-white-light mb-4">Datos del vehiculo al dia</h5>

    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        <div *ngFor="let vehicle of vehicles" class="p-4 bg-gray-100 dark:bg-[#1e293b] rounded-lg shadow-md">
            <!-- Imagen y detalles -->
            <div class="flex flex-col items-center">
                <img src="../../../../../../assets/images/car1.png" class="w-36 h-24 rounded-md object-cover mb-3" alt="{{ vehicle.brand }}" />
                <h6 class="text-lg font-semibold text-gray-800 dark:text-white">{{ vehicle.vehicle_model }}</h6>
                <p class="text-sm text-gray-600 dark:text-white-light">Kilometraje: {{ vehicle.km }} km</p>
            </div>

            <!-- Estado -->
            <!-- <div class="mt-3 flex justify-center">
                <span class="px-3 py-1 text-xs font-medium text-white rounded-full" [ngClass]="item.colorClass">
                    {{ item.status }}
                </span>
            </div> -->

            <!-- Botón de acción -->
            <div class="mt-4 flex justify-center text-center">
                <button (click)="selectVehicle(vehicle.id)" class="btn btn-primary text-center justify-center text-white py-2 px-4 rounded-lg text-sm transition-all">
                    Ver orden de servicio
                  </button>
            </div>
        </div>
    </div>
</div>
